module.exports = __webpack_public_path__ + "static/media/citylights-xxl.802af4eb.jpg";